export default "__VITE_ASSET__81368ca4__"